import { useQuery } from '@tanstack/react-query'

import { getChannelPairing } from './api'

const POLL_INTERVAL_MS = 3_000

export function channelPairingQueryKey(tenantId: string, channelId: string) {
  return ['onboarding', 'pairing', tenantId, channelId] as const
}

/**
 * Poll do QR/pairing do canal. So habilitado quando ha um `channelId` resolvido (ver
 * `wizardSteps.ts#deriveChannelId` — a saga so cria o canal depois de alguns passos, entao o id
 * fica `undefined` por um instante no inicio do provisioning). Para de repetir assim que o canal
 * aparece `Connected` — o QR deixa de existir a partir dai.
 */
export function useChannelPairing(tenantId: string | undefined, channelId: string | undefined) {
  const enabled = tenantId !== undefined && channelId !== undefined

  return useQuery({
    queryKey: channelPairingQueryKey(tenantId ?? '', channelId ?? ''),
    queryFn: () => getChannelPairing(tenantId ?? '', channelId ?? ''),
    enabled,
    refetchInterval: (query) =>
      query.state.data?.status === 'Connected' ? false : POLL_INTERVAL_MS,
  })
}
